const prefetchedImages = new Set<string>();

export function getDesignPreviewUrl(design: {
  thumbnail_url?: string | null;
  design_image_url?: string | null;
}) {
  return design.thumbnail_url || design.design_image_url || "";
}

export function getCatalogProductImageUrl(product: {
  variants?: Array<{
    is_enabled?: boolean;
    mockups?: Array<{
      image_url?: string | null;
      vector_image_url?: string | null;
    }> | null;
  }> | null;
}) {
  const variants = product.variants?.filter((variant) => variant.is_enabled) ?? [];
  const mockups = variants.flatMap((variant) => variant.mockups ?? []);
  return mockups.find((mockup) => mockup.image_url)?.image_url
    || mockups.find((mockup) => mockup.vector_image_url)?.vector_image_url
    || "";
}

export function prefetchImages(urls: Array<string | null | undefined>, limit = 12) {
  if (typeof window === "undefined") return;

  const uniqueUrls = urls
    .filter((url): url is string => Boolean(url))
    .filter((url) => {
      if (prefetchedImages.has(url)) return false;
      prefetchedImages.add(url);
      return true;
    })
    .slice(0, limit);

  if (uniqueUrls.length === 0) return;

  const run = () => {
    uniqueUrls.forEach((url) => {
      const link = document.createElement("link");
      link.rel = "prefetch";
      link.as = "image";
      link.href = url;
      document.head.appendChild(link);

      const image = new Image();
      image.decoding = "async";
      image.src = url;
    });
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(run, { timeout: 1500 });
  } else {
    globalThis.setTimeout(run, 250);
  }
}
